import { oneProfileSetup, users } from "@one-profile/core";
import Root from "./App";

const { REACT_APP_ENV, REACT_APP_ACTIVATION_ENVS, Countries } = JSON.parse(process.env.REACT_APP_IDCG_ENV)["frontend"];

let options = {};

if (REACT_APP_ACTIVATION_ENVS.includes(REACT_APP_ENV)) {
  options = {
    activationFn: function (accessToken, currentUser) {
      return users.getMe(accessToken).then((user) => {
        return Countries.includes(user.homeOffice.country);
      });
    }
  }
}

const profileSetup = oneProfileSetup(Root, options);

export const { bootstrap, mount, unmount, config, update } = profileSetup;